import routes from '../constants/routes';
import authService from '../services/auth';
import queryString from '../services/queryString';
import redirect from '../actions/redirect';
import routing from '../services/routing';

const redirectAction = (action: string) => {
    switch (action) {
        case 'signUp':
            return routes.SIGN_UP;
        case 'forgotPassword':
            return routes.FORGOT_PASSWORD;
        default:
            return routes.SIGN_IN;
    }
};

export const authorize = async () => {
    try {
        const res = await authService.getProfile();
        if (res.data !== undefined) {
            const params = queryString.parse(routing.location.search);
            const res = await authService.authorize(params);
            const data: { redirect_uri: string } = res.data;
            if (data && data.redirect_uri) {
                redirect(data);
            } else {
                const params = queryString.parse(routing.location.search);
                const redirectRoute = redirectAction(params.action);
                routing.push(redirectRoute);
            }
        }
    } catch (error) {
        if (error.message === 'USER_NOT_LOGGED_IN') {
            const params = queryString.parse(routing.location.search);
            const redirectRoute = redirectAction(params.action);
            routing.push(redirectRoute);
            // routing.push(routes.SIGN_IN);
        } else {
            throw error;
        }
    }
};

export default authorize;
